<template>
    <!-- <b-modal
      :ok-disabled="disabled"
      :cancel-disabled="disabled"
      @ok="submit"
      class="in-modal"
      ok-title="ثبت"
      cancel-title="لغو"
      id="modal-wallet-report"
      title="جزییات تراکنش"
    >
     
  
    
    </b-modal> -->
    <section class="modal-show" @click.self="$emit('closeModal')">
      <slot/>
    </section>
  </template>
  <script>
import {BModal, BFormGroup, BFormCheckbox, BFormFile, BFormInput} from "bootstrap-vue";
export default {
  components: {
   BModal, BFormGroup, BFormCheckbox, BFormFile, BFormInput
   },
  name: "ModalWalletReport",
  props: {
    
    UserId:Number
    
  },
  data() {
    return {
      
    };
  },
  watch: {
    value(newVal) {
      this.advertise = newVal;
    },
    advertise(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {
   
    // loadModels(item) {
    //   this.advertise.linkable_id = null;
    //   if (item) {
    //     this.models = item.models;
    //     if (this.models != null && this.models != "" && this.models[0].title) {
    //       this.modelLable = "title";
    //       this.linkUrl = false;
    //     } else if (
    //       this.models != null &&
    //       this.models != "" &&
    //       this.models[0].name
    //     ) {
    //       this.modelLable = "name";
    //       this.linkUrl = false;
    //     } else if (this.models != null && this.models == "link_url") {
    //       this.linkUrl = true;
    //     }
    //     if (this.models == null) {
    //       this.linkUrl = false;
    //     }
    //   }
    // },
  },
}

  </script>
  <style scoped>
.modal-show{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 11000;
  background-color: #0000004d;
  display: grid;
  place-items: center;
}

</style>